import { render, staticRenderFns } from "./draggable-resizable.vue?vue&type=template&id=751a149b"
import script from "./draggable-resizable.vue?vue&type=script&lang=js"
export * from "./draggable-resizable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports